import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import CommunityListLayer from "../components/FreeCommunityListLayer";
 
 
const CommunityListPage = () => {
  return (
    <>
 
 
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Free Communities  </h5><Breadcrumb title="Free Community" /></div>
 
        <CommunityListLayer />
 
 
    </>
  );
};
 
export default CommunityListPage;
 
 